/**
 * Petit store pour piloter l'ouverture de SnoozeSheet. Le composant
 * SnoozeSheet est rendu dans App.svelte et lit threadId pour s'afficher.
 */

interface SnoozeState {
  threadId: string | null;
}

export const snoozeState = $state<SnoozeState>({ threadId: null });

export function openSnooze(threadId: string): void {
  snoozeState.threadId = threadId;
}

export function closeSnooze(): void {
  snoozeState.threadId = null;
}
